import * as Yup from "yup";

export const BankSchema = Yup.object().shape({
  name: Yup.string().min(3, "The name is too short").max(25, "The name is too long").required("Please enter the bank name"),
  account: Yup.string().min(3, "The name is too short").max(25, "The name is too long").required("Please enter the account number"),
  currency: Yup.string().required("Please select the currency"),
  opbal: Yup.number().required("Please enter opening balance").positive().integer()
});
